import { useState, useEffect } from "react";

// Renault Emblem Component - verwendet das offizielle Logo
export const RenaultEmblem = ({ className = "", size = 60, variant = "dark", style = {}, id = "" }) => {
  const filterStyle = variant === "light" 
    ? { filter: "brightness(0) saturate(100%) invert(89%) sepia(66%) saturate(497%) hue-rotate(6deg) brightness(103%) contrast(101%)", ...style }
    : style;
  
  return (
    <img 
      src="/renault-logo.png" 
      alt="Renault" 
      width={size} 
      height={size}
      className={className}
      style={filterStyle}
      id={id}
    />
  );
};

const SplashScreen = ({ onComplete }) => {
  const [phase, setPhase] = useState(0); 
  // 0 = Logo normal
  // 1 = Logo vergrößert sich
  // 2 = Logo ist riesig, Seite blendet ein
  // 3 = Fertig

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 1000);   // Nach 1s: Zoom + Verblassen startet
    const t2 = setTimeout(() => setPhase(2), 1700);   // Nach 1.7s: Fertig
    const t3 = setTimeout(onComplete, 1700);
    
    return () => [t1, t2, t3].forEach(clearTimeout);
  }, [onComplete]);

  if (phase === 2) return null;

  // Zoom-Faktor: 1 -> 30 (Logo wird riesig)
  const scale = phase === 0 ? 1 : 30;
  
  // ALLES verblasst ab Phase 1
  const opacity = phase === 0 ? 1 : 0;

  return (
    <div 
      className="fixed inset-0 z-[9999] overflow-hidden"
      style={{ pointerEvents: phase >= 1 ? 'none' : 'auto' }}
    >
      {/* Schwarzer Hintergrund - verblasst mit allem anderen */}
      <div 
        className="absolute inset-0 bg-black"
        style={{
          opacity: opacity,
          transition: 'opacity 700ms ease-out',
        }}
      />
      
      {/* Logo - vergrößert sich UND verblasst */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div
          style={{
            transform: `scale(${scale})`,
            opacity: opacity,
            transition: 'transform 700ms cubic-bezier(0.4, 0, 0.2, 1), opacity 700ms ease-out',
          }}
        >
          <RenaultEmblem 
            size={140}
            variant="light"
          />
        </div>
      </div>

      {/* Text - verblasst mit allem */}
      <div 
        className="absolute inset-0 flex flex-col items-center justify-center"
        style={{
          opacity: opacity,
          transition: 'opacity 700ms ease-out',
          paddingTop: '220px',
        }}
      >
        <h1 className="font-nouvel text-4xl md:text-5xl text-white tracking-wide mb-3">
          Auto Thurm
        </h1>
        <p className="font-read text-sm md:text-base text-[#888B8D]">
          Ihr Renault & Dacia Partner
        </p>
      </div>
    </div>
  );
};

export default SplashScreen;
